<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div class="card_container" style="flex: 0 0 20%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button active_tab"
                style="width: 100px; height: 60px"
              >
                <h3 class="text-white">{{ transactionCount }}</h3>
              </div>
              <div class="text-center voucher_type mt-2">
                {{ $t("text.pumpTransactions.title") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section mr-3 pmp__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-6">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px"
              >
                {{ $t("text.pumpTransactions.title") }} ({{
                  pump && pump.displayName ? pump.displayName : null
                }})
              </div>
            </div>
            <div class="col-md-6 drop_down_input_group">
              <div class="drop_down_section mt-2 mr-2">
                <div class="drop_down_div align-items-center">
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    :color="$store.getters.getDatePickerColor"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="products_summary__wrapper mt-3 pb-3">
        <div class="row" style="margin-right: 0px">
          <div
            class="col-md-3 pump_trans_mob"
            style="padding-right: 0px !important"
          >
            <div class>
              <div class="pump__transaction__header_1">
                <div
                  class="row gx-5"
                  style="display: flex; align-items: center"
                >
                  <p class="col font-weight-bold">
                    {{ totalVolume }} {{ $t("text.units.litres") }}
                  </p>
                  <div class="col">
                    <span>
                      <img
                        src="@/assets/img/measure.png"
                        width
                        class
                        height="45px"
                      />
                    </span>
                  </div>
                </div>
                <div class="mt-3">
                  <p style="font-size: 17px">
                    {{ $t("text.pumpTransactions.totalVolume") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- //second -->
          <!-- EX -->
          <!-- <div
            class="col-md-3 pump_trans_mob"
            style="padding-right: 0px !important"
          >
            <div class>
              <div class="pump__transaction__header_3 row">
                <p class="col-5 font-weight-bold">{{ transactionCount }}</p>
                <p class="mt-3 col-4" style="font-size: 17px">
                  {{ $t("text.pumpTransactions.totalNumber") }}
                </p>
                <div class="col-3">
                  <span>
                    <img
                      src="@/assets/img/to-do.png"
                      width
                      class
                      height="45px"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div> -->
          <div
            class="col-md-3 pump_trans_mob"
            style="padding-right: 0px !important"
          >
            <div class>
              <div class="pump__transaction__header_3">
                <div
                  class="row gx-5"
                  style="display: flex; align-items: center"
                >
                  <p class="col font-weight-bold">{{ transactionCount }}</p>

                  <div class="col">
                    <span>
                      <img
                        src="@/assets/img/to-do.png"
                        width
                        class
                        height="45px"
                      />
                    </span>
                  </div>
                </div>
                <div class="mt-3">
                  <p class="" style="font-size: 17px">
                    {{ $t("text.pumpTransactions.totalNumber") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- third -->
          <!-- <div
            class="col-md-4 pump_trans_mob"
            style="padding-right: 0px !important"
          >
            <div class>
              <div class="pump__transaction__header_3">
                <p class>{{ transactionCount }}</p>
                <div class="mt-3">
                  <span>
                    <img src="@/assets/img/to-do.png" width class />
                  </span>
                </div>
                <p class="mt-4">
                  {{ $t("text.pumpTransactions.totalNumber") }}
                </p>
              </div>
            </div>
          </div> -->
          <div
            class="col-md-3 pump_trans_mob"
            style="padding-right: 0px !important"
          >
            <div class>
              <div class="pump__transaction__header_2">
                <div
                  class="row gx-5"
                  style="display: flex; align-items: center"
                >
                  <p class="col font-weight-bold">
                    {{ averageLitre }} {{ $t("text.units.litres") }}
                  </p>
                  <div class="col">
                    <span>
                      <img
                        src="@/assets/img/analytics (1).png"
                        width
                        class
                        height="45px"
                      />
                    </span>
                  </div>
                </div>
                <div class="mt-3">
                  <p class="" style="font-size: 17px">
                    {{ $t("text.pumpTransactions.avgLitres") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- fourth - amount -->
          <div
            class="col-md-3 pump_trans_mob"
            style="padding-right: 0px !important"
          >
            <div class>
              <div
                class="pump__transaction__header_2"
                style="background: green"
              >
                <div class="row" style="display: flex; align-items: center">
                  <p class="col font-weight-bold" style="font-size: 18px">
                    {{ currency }}{{ totalAmt }}
                  </p>
                  <div class="col">
                    <span>
                      <img
                        src="@/assets/img/wallet (6).svg"
                        width
                        class
                        height="45px"
                      />
                    </span>
                  </div>
                </div>
                <div class="mt-3">
                  <p class="h6" style="font-size: 17px">
                    {{ $t("text.pumpTransactions.totalAmount") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            class="col-md-4 pump_trans_mob"
            style="padding-right: 0px !important"
          >
            <div class>
              <div class="pump__transaction__header_2">
                <p class>
                  {{ averageLitre.toFixed(2) }} {{ $t("text.units.litres") }}
                </p>
                <div class="mt-3">
                  <span>
                    <img src="@/assets/img/analytics (1).png" width class />
                  </span>
                </div>
                <p class="mt-4">{{ $t("text.pumpTransactions.avgLitres") }}</p>
              </div>
            </div>
          </div> -->
        </div>
      </section>
      <div class="section-2 mt-3">
        <section>
          <div class="dashboard__table__section mt-3">
            <div class="branch__sales__text_header">
              <div class="row">
                <div class="col-md-8">
                  <span class="sec_text_color">
                    <img src="@/assets/img/hand (1).png" class="mr-3" />
                    {{ $t("text.pumpTransactions.branchSales") }}
                    {{
                      $d(new Date(startDate), "short", this.$root.$i18n.locale)
                    }}
                    {{ $t("text.and.text") }}
                    {{
                      $d(new Date(endDate), "short", this.$root.$i18n.locale)
                    }}
                  </span>
                </div>
                <div class="col-md-4 text-right"></div>
              </div>
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :dataBound="dataBound"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :excelQueryCellInfo="excelQueryCellInfo"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="80" field="index" headerText="#"></e-column>
                  <e-column
                    field="date"
                    width="200"
                    :headerText="$t('text.pumpTransactions.dateTime')"
                    :format="formatOptions"
                    type="date"
                  ></e-column>
                  <e-column
                    field="productName"
                    width="200"
                    :headerText="$t('text.pumpTransactions.productName')"
                  ></e-column>
                  <e-column
                    field="pumpName"
                    width="200"
                    :headerText="$t('text.pumpTransactions.pumpName')"
                  ></e-column>
                  <e-column
                    field="openingRead"
                    format="N2"
                    width="200"
                    :headerText="$t('text.pumpTransactions.openingReading')"
                  ></e-column>
                  <e-column
                    field="closingRead"
                    format="N2"
                    width="200"
                    :headerText="$t('text.pumpTransactions.closingReading')"
                  ></e-column>
                  <e-column
                    field="totalSale"
                    format="N2"
                    width="200"
                    :headerText="$t('text.pumpTransactions.volumeDispensed')"
                  ></e-column>
                  <e-column
                    field="priceSold"
                    format="N2"
                    width="200"
                    :headerText="$t('text.pumpTransactions.pricePerLitre')"
                  ></e-column>
                  <e-column
                    field="priceSoldCash"
                    format="N2"
                    width="200"
                    :headerText="$t('text.form.amount')"
                  ></e-column>
                  <e-column
                    field="totalSale"
                    format="N2"
                    width="200"
                    :headerText="$t('text.pumpTransactions.volumeDispensed')"
                  ></e-column>
                  <e-column
                    field="staffName"
                    width="200"
                    :headerText="$t('text.pumpTransactions.dispensedBy')"
                  ></e-column>
                  <e-column
                    field="salesType"
                    width="200"
                    :headerText="$t('text.pumpTransactions.salesType')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </section>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import countryProducts from "@/products";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "PumpTransactions",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      branch: {},
      branchId: null,
      startDate: this.$route.date
        ? this.$moment(this.$route.date, "DD-MM-YYYY").format("MMMM D, YYYY")
        : this.$moment().format("MMMM D, YYYY"),
      endDate: this.$route.date ? null : this.$moment().format("MMMM D, YYYY"),
      // pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      backgroundUrl,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      showLoader: false,
      showAll: false,
      transactionCount: 0,
      totalVolume: 0,
      averageLitre: 0,
      totalAmt: 0,
      currency: "",
      pumpId: "",
      date: this.$route.query.date,
      pump: { displayName: "" },
    };
  },
  created() {
    document.title = "Pumps Transactions:: Epump Retail Outlet";

    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Pumps Transactions:: ${branch.name} Retail Outlet`;
    });

    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }

    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$moment(this.$route.query.startDate).format(
        "D-M-YYYY"
      );
      this.dateRange.end = this.$moment(this.$route.query.endDate).format(
        "D-M-YYYY"
      );
    } else {
      this.dateRange.start = this.pluginStartDate;
      this.dateRange.end = this.pluginEndDate;

      this.$router.replace({
        name: this.$route.name,
        query: {
          branchId: this.$route.query.branchId
            ? this.$route.query.branchId
            : this.branch.id,
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : "",
          pumpId: this.$route.params.pumpId,
          dealerId: this.$route.query.dealerId,
          groupId: this.$route.query.groupId,
          regionId: this.$route.query.regionId,
          startDate: this.$moment(this.pluginStartDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
          endDate: this.$moment(this.pluginEndDate, "DD-MM-YYYY").format(
            "MMMM D, YYYY"
          ),
        },
      });
    }

    this.showLoader = true;
    // this.getPumpTransactions();
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {},
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.$router.replace({
          name: this.$route.name,
          query: {
            branchId: this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id,
            companyId: this.$route.query.companyId
              ? this.$route.query.companyId
              : "",
            pumpId: this.$route.params.pumpId,
            dealerId: this.$route.query.dealerId,
            groupId: this.$route.query.groupId,
            regionId: this.$route.query.regionId,
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });
        this.getPumpTransactions();
        this.getPumpTransactionsSummary();
      }
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.pumpId = this.$route.query.pumpId;
          // let queryDate = this.$route.query.date;
          // if (queryDate !== null && queryDate !== undefined) {
          //   this.pluginStartDate = this.$moment(new Date(queryDate)).format(
          //     "D-M-YYYY"
          //   );
          //   this.pluginEndDate = this.$moment(new Date(queryDate)).format(
          //     "D-M-YYYY"
          //   );
          //   this.startDate = this.$moment(
          //     new Date(queryDate),
          //     "DD-MM-YYYY"
          //   ).format("MMMM D, YYYY");
          //   this.endDate = this.$moment(
          //     new Date(queryDate),
          //     "DD-MM-YYYY"
          //   ).format("MMMM D, YYYY");
          // }

          // this.dateRange.start = this.pluginStartDate;
          // this.dateRange.end = this.pluginEndDate;
          let pumps = [];
          this.getPumps();
          this.getPumpTransactions();
          this.getPumpTransactionsSummary();
        }
      }
    },
  },
  mounted() {
    // this.pumpId =  this.$route.params.pumpId
    // console.log(this.pumpId)
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    activateTab(voucher_type) {
      this.activeTab = voucher_type;
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    changeRoute(route) {
      this.$router.push({ name: route });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getPumpTransactions() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/PumpTransactions?pumpId=${
            this.$route.params.pumpId
          }&strtDate=${
            this.$route.query.startDate
              ? this.$route.query.startDate
              : this.startDate
          }&endDate=${
            this.$route.query.endDate ? this.$route.query.endDate : this.endDate
          }&branchId=${
            this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id
          }&esales=false`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          let totalVol = response.data.reduce((acc, curr) => {
            return acc + curr.totalSale;
          }, 0);
          let index = 0;
          response.data.forEach((element) => {
            element.index = ++index;
          });
          // this.totalVolume = totalVol;
          // this.transactionCount = response.data.length;
          // this.averageLitre =
          //   response.data.length === 0
          //     ? 0
          //     : this.totalVolume / this.transactionCount;
          // this.totalVolume = this.convertThousand(this.totalVolume);
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getPumpTransactionsSummary() {
      this.totalAmt = this.$t("text.omit.checking");
      this.totalVolume = this.$t("text.omit.checking");
      this.averageLitre = this.$t("text.omit.checking");
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/PumpTransactions/Summary?pumpId=${
            this.$route.params.pumpId
          }&strtDate=${
            this.$route.query.startDate
              ? this.$route.query.startDate
              : this.startDate
          }&endDate=${
            this.$route.query.endDate ? this.$route.query.endDate : this.endDate
          }&branchId=${
            this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id
          }&esales=false`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response.data);
          this.currency = response.data.currency;
          this.totalAmt = this.convertThousand(response.data.totalSales);
          this.totalVolume = this.convertThousand(response.data.totalSalesVol);
          this.averageLitre = response.data.averageVolPerTranx.toFixed(2);
          this.transactionCount = response.data.totalTransactionCount;
        })
        .catch((error) => {});
    },
    getPumps() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Pumps/${
            this.$route.query.branchId
              ? this.$route.query.branchId
              : this.branch.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((element) => {
            if (element.productName !== undefined) {
              if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product1
              ) {
                element.color = "#d8991c";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product2
              ) {
                element.color = "#0fce29";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product3
              ) {
                element.color = "#00aced";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product4
              ) {
                element.color = "purple";
              }
            } else if (element.displayName !== undefined) {
              if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product1)
              ) {
                element.color = "#d8991c";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product2)
              ) {
                element.color = "#0fce29";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product3)
              ) {
                element.color = "#00aced";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product4)
              ) {
                element.color = "purple";
              }
            }
          });
          this.pump = response.data.filter((pump) => pump.id == this.pumpId)[0];
        })
        .catch((error) => {});
    },
    convertThousand(req) {
      if (!isFinite(req)) {
        return "0.00";
      }
      return req
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
